<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Coupon
        </v-card-title>
        <v-card-text>
          <v-row>
            <!-- Coupon Name -->
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                label="Coupon Name"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <!-- Start Date -->
            <v-col sm="4">
              <v-menu
                v-model="date_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.start_date"
                    label="Start Date"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="form.start_date = null"
                    :error-messages="errors.start_date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.start_date"
                  @change="date_menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- End Date -->
            <v-col sm="4">
              <v-menu
                v-model="end_date_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.end_date"
                    label="End Date"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="form.end_date = null"
                    :error-messages="errors.end_date"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.end_date"
                  @change="end_date_menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Coupon Type -->
            <v-col sm="4">
              <v-text-field
                v-model="form.type"
                label="Coupon Type"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <!-- Coupon Value -->
            <v-col sm="4">
              <v-text-field
                v-model="form.value"
                label="Coupon Value"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <!-- Coupon Quantity per Use -->
            <v-col sm="4">
              <v-text-field
                v-model="form.no_per_use"
                label="Coupon Quantity per Use"
                outlined
                dense
              ></v-text-field>
            </v-col>

            <!-- Minimum Order Value -->
            <v-col sm="4">
              <v-text-field
                v-model="form.min_order_value"
                label="Minimum Order Value"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-5"></v-divider>

          <!-- Save Button -->
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Coupon
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
  
  <script>
import axios from "axios";

export default {
  name: "CouponCreatePage",
  data() {
    return {
      form: {
        name: "",
        start_date: "",
        end_date: "",
        type: "",
        value: "",
        no_per_use: null,
        min_order_value: null,
      },
      date_menu: false,
      end_date_menu: false,

      isLoading: false,
      errors: {},
    };
  },
  methods: {
    // async save() {
    //   try {
    //     this.isLoading = true;
    //     if (
    //       !this.form.name ||
    //       !this.form.start_date ||
    //       !this.form.end_date ||
    //       !this.form.type ||
    //       !this.form.value
    //     ) {
    //       this.errors = { form: "Please fill out all required fields." };
    //       return;
    //     }

    //     const response = await axios.post("/coupons", this.form, {
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem("token")}`, // Use proper token if needed
    //       },
    //     });

    //     if (response.data.success) {
    //       this.$router.push("/coupons"); // Redirect after successful coupon creation
    //     }
    //   } catch (error) {
    //     console.error("Error saving coupon:", error);
    //     this.errors = { form: "An error occurred while saving the coupon." };
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    async save() {
      try {
        this.isLoading = true;

        let coupons = await axios.post("/coupons", this.form);
        this.coupons = coupons.data.data;

        // Upload images
        // await this.uploadImages();

        console.log("coupon saved:", coupons.data);
        this.$router.push("/coupons");
      } catch (error) {
        console.error("Error saving product:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
  